import { Observable } from 'rxjs';
import { Grupo } from './grupo';
import { Modulo } from './modulo';
import { PaisTipoCambioTabela } from './pais-tipo-cambio-tabela';
export class Pais {
    id: number;
    codigo: string;
    grupoDisplay: string
    nombre: string;
    moneda: string;
    idioma: string;
    tipoCambio: number;
    descuentoCategoria: boolean;
    mostrarCategoria: boolean;
    autoAprobacionInventario: boolean;
    autoAprobacionSellOut: boolean;
    monedaLocal: boolean;
    modulos: Modulo[];
    grupos: Grupo[];
    paisTipoCambio: PaisTipoCambioTabela[];
}
export abstract class PaisData {
    abstract getList():  Observable<Pais[]>;
}
